// Third party libraries
import Moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Segment } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';

// Components
import BottomNav from '../../../../components/bottomNav/BottomNav';
import HorizontalPlanCard from './components/horizontalPlanCard';
import PanelNav from '../../../../components/nav/PanelNav';
import SetupNav from '../../components/SetupNav';

// Redux Store
import { closeLoader, openLoader } from '../../../../../redux-store/loader';

// Styled components
import { Wrapper } from '../../../../styled/wrappers';

// Models
import PaymentModel, { PeriodicityEnum, Plan } from '../../../../../models/payment';

// Locales
import I18n from '../../../../../i18n';

// Styles
import './index.scss';

const Plans = () => {

    const navigate = useNavigate();

    const pathname = window.location.pathname;

    const dispatch = useDispatch();

    const [periodicity, setPeriodicity] = useState<PeriodicityEnum>(PeriodicityEnum.Annual);
    const [selectedPlan] = useState<Plan | undefined>();
    const [plans, setPlans] = useState<Plan[]>([]);
    const [maxStudents, setMaxStudents] = useState<number>(3);
    const [expiredLicense, setExpiredLicense] = useState<boolean>(window.location.hash.includes('/expiredLicense/'));

    const getData = useCallback(async () => {

        dispatch(openLoader());

        try {

            const plans = await PaymentModel.getPlans();

            setPlans(plans);

        } catch (e) { } finally {

            dispatch(closeLoader());

        }

    }, [dispatch]);

    useEffect(() => {

        getData();

    }, [getData]);

    useEffect(() => {

        PaymentModel.getCurrentLicense().then(currentLicense => {

            const isExpiredLicense: boolean = !!!currentLicense.endDate || Moment(currentLicense.endDate).startOf('day').isBefore(Moment().startOf('day'));
            if (!isExpiredLicense) {

                setMaxStudents(currentLicense.maxStudents);

            } else if (isExpiredLicense && !pathname.includes('/expiredLicense/')) {

                navigate('/expiredLicense/plans');
                setExpiredLicense(true);

            }

        });

    }, [navigate, pathname]);

    const onSelectPlan = (planId: string) => navigate(`/${expiredLicense ? 'expiredLicense' : 'setup'}/checkout?periodicity=${periodicity}&plan=${planId}`);

    //TODO: Ampliar suscripción -- Calcular los plazos para los planes superiores al actual (regla de 3, si sobra tanto dinero, a cuánto equivaldría en el plan nuevo --> ese número de días irá a Stripe como días de trial)

    const renderExpiredLicenseMessage = () => <div className='expiredLicenseText'>
        <h2>{I18n.t('setup.expiredLicenseTexts.title')}</h2>
        <br />
        <span>{I18n.t('setup.expiredLicenseTexts.description')}</span>
        <br />
        <br />
        <ul>
            <li>{I18n.t('setup.expiredLicenseTexts.reason1')}</li>
            <li>{I18n.t('setup.expiredLicenseTexts.reason2')}</li>
            <li>{I18n.t('setup.expiredLicenseTexts.reason3')}</li>
        </ul>
        <br />
        <span>{I18n.t('setup.expiredLicenseTexts.whatCanYouDo')}</span>
        <br />
        <br />
        <span dangerouslySetInnerHTML={{ __html: I18n.t('setup.expiredLicenseTexts.contractOrContact') }} />
    </div>;

    const renderPlans = (periodicity: PeriodicityEnum, selectedPlan: Plan | undefined) => {

        if (!plans || plans.length === 0) return <div>No plans</div>

        return plans.map(plan => {

            const offer = plan.generalOffers?.find(offer => offer.type === periodicity);

            return <HorizontalPlanCard key={plan._id} maxStudents={maxStudents} plan={plan} offer={offer} periodicity={periodicity} selected={selectedPlan?._id === plan._id} onSelect={() => onSelectPlan(plan._id)} />
        })

    }

    return <Wrapper>
        <PanelNav active='setup' disableMenu={expiredLicense} />
        <SetupNav active='subscription' disableMenu={expiredLicense} />
        <Container style={{ paddingTop: '20px' }}>
            <div className='inner'>
                <div className='p-flex'>
                    <div className='p-content'>
                        <div className='a-wrapper'>
                            <div className='a-f-wrapper'>
                                <div className='plans'>
                                    {expiredLicense && renderExpiredLicenseMessage()}
                                    <Segment>
                                        <div className='periodicitySelector'>
                                            <span className={`selector ${periodicity === PeriodicityEnum.Monthly ? 'active' : ''}`} onClick={() => setPeriodicity(PeriodicityEnum.Monthly)}>{I18n.t('landing.monthly')}</span>
                                            <span className={`selector ${periodicity === PeriodicityEnum.Annual ? 'active' : ''}`} onClick={() => setPeriodicity(PeriodicityEnum.Annual)}>{I18n.t('landing.annual')}</span>
                                        </div>

                                        {renderPlans(periodicity, selectedPlan)}

                                    </Segment>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
        <BottomNav active='setup' disableMenu={expiredLicense} />
    </Wrapper>;

}

export default Plans;